import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
};

const Thoughts = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api
      .get("/posts")
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]));
  }, []);

  return (
    <section
      id="thoughts"
      data-theme="dark"
      className="sec-dark relative px-6 md:px-12 py-28 md:py-40"
      data-testid="thoughts-section"
    >
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <div className="eyebrow">04 · Thoughts &amp; News</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-extrabold text-[32px] md:text-[52px] leading-[1.02] t-fg tracking-[-0.035em] mt-8 mb-16 md:mb-24 max-w-[20ch]">
            Notes from the work<span className="t-terra">.</span>
          </h2>
        </Reveal>

        {posts === null ? (
          <div className="t-faint text-[14px]" data-testid="thoughts-loading">Loading…</div>
        ) : posts.length === 0 ? (
          <div className="t-dim text-[16px]" data-testid="thoughts-empty">
            New thoughts are on their way.
          </div>
        ) : (
          <div className="border-b" style={{ borderColor: "var(--hair-soft)" }}>
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={Math.min(i * 0.05, 0.2)} y={20}>
                <article
                  className="grid grid-cols-12 gap-x-6 md:gap-x-16 gap-y-4 py-12 md:py-14 border-t"
                  style={{ borderColor: "var(--hair-soft)" }}
                  data-testid={`thought-item-${p.id}`}
                >
                  <div className="col-span-12 md:col-span-3 flex md:flex-col items-center md:items-start gap-4 md:gap-5">
                    <div className="text-[13px] t-dim">{fmtDate(p.created_at)}</div>
                    {p.tag && <span className="tag-pill">{p.tag}</span>}
                  </div>
                  <div className="col-span-12 md:col-span-8">
                    <h3 className="font-display font-bold text-[21px] md:text-[28px] leading-[1.15] t-fg tracking-[-0.025em]">
                      {p.title}
                    </h3>
                    <p className="mt-5 text-[15px] md:text-[16px] leading-[1.8] t-dim max-w-[68ch] whitespace-pre-line">
                      {p.body}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Thoughts;
